<template>
  <div>
    <a class="PdfWithModal clickable" role="button" @click.prevent="openModal">
      {{ linkText }}
    </a>
    <Teleport to="body">
      <b-modal v-model="isPDFModalActive" :width="920" has-modal-card scroll="keep">
        <div class="modal-card">
          <!-- <header class="modal-card-head">
            <p class="modal-card-title">
              {{ $t("feedbackModal.feedback-guide") || "Visualiser le document" }}
            </p>
            <button
              type="button"
              class="delete"
              aria-label="close"
              @click="isPDFModalActive = false"
            ></button>
          </header> -->
          <section v-if="isPDFModalActive && pdfSource" class="modal-card-body">
            <div ref="pdfScrollContainer" class="pdf-scroll-container">
              <VuePdfEmbed
                v-if="isPDFModalActive && pdfSource"
                class="pdfViewer"
                :source="pdfSource"
                :page="page"
                :width="850"
                @loaded="handlePdfLoaded"
                @loading-failed="handlePdfError"
              />
            </div>
          </section>
          <section v-if="!pdfSource" class="modal-card-body">
            <div class="error-message">
              {{ $t("feedbackModal.feedback-guide") || "Erreur: Aucun fichier PDF spécifié" }}
            </div>
          </section>
          <footer v-if="pdfNumPages > 0" class="modal-card-foot">
            <b-button
              v-show="page > 1"
              type="is-primary"
              class="navigationButton prev"
              @click="goToPreviousPage"
            >
              {{ $t("registerPage.precedent") }}
            </b-button>
            <b-button
              v-show="page < pdfNumPages"
              type="is-primary"
              class="navigationButton next"
              @click="goToNextPage"
            >
              {{ $t("registerPage.suivant") }}
            </b-button>
          </footer>
        </div>
      </b-modal>
    </Teleport>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue"
import type { PDFDocumentProxy } from "pdfjs-dist/types/src/display/api"
import VuePdfEmbed from "vue-pdf-embed"
import { BButton, BModal } from "buefy"

// Configuration du worker PDF.js
import { GlobalWorkerOptions } from "pdfjs-dist"
GlobalWorkerOptions.workerSrc = `https://cdn.jsdelivr.net/npm/pdfjs-dist@4.10.38/build/pdf.worker.min.mjs`

export default defineComponent({
  name: "PDFLinkWithModal",
  components: {
    VuePdfEmbed,
    BButton,
    BModal,
  },
  props: {
    fileName: {
      type: String,
      default: "",
    },
    linkText: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      isPDFModalActive: false,
      page: 1,
      pdfNumPages: 0,
      pdfSource: "",
    }
  },
  computed: {},
  watch: {
    fileName() {
      this.loadPdfSource()
    },
  },
  mounted() {
    this.loadPdfSource()
  },
  methods: {
    async loadPdfSource(): Promise<void> {
      if (!this.fileName) {
        this.pdfSource = ""
        return
      }
      try {
        // Utiliser import dynamique de Vite pour les assets
        const pdfModule = await import(`../../assets/pdf/${this.fileName}.pdf`)
        this.pdfSource = pdfModule.default
      } catch (error) {
        console.error("Error loading PDF:", error)
        this.pdfSource = ""
      }
    },
    openModal(): void {
      this.page = 1
      this.isPDFModalActive = true
    },
    handlePdfLoaded(documentProxy: PDFDocumentProxy | null): void {
      if (documentProxy?.numPages) {
        this.pdfNumPages = documentProxy.numPages
      }
    },
    handlePdfError(error: Error): void {
      console.error("Erreur lors du chargement du PDF", error)
    },
    goToNextPage(): void {
      if (this.page < this.pdfNumPages) {
        this.page += 1
        this.scrollToTop()
      }
    },
    goToPreviousPage(): void {
      if (this.page > 1) {
        this.page -= 1
        this.scrollToTop()
      }
    },
    scrollToTop(): void {
      const container = this.$refs.pdfScrollContainer as HTMLElement
      if (container) {
        container.scrollTop = 0
      }
    },
  },
})
</script>

<style lang="scss" scoped>
.PdfWithModal {
  &.clickable:hover {
    cursor: pointer;
  }
}

.modal-card-foot {
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;

  .navigationButton {
    &.prev {
      grid-column: 1;
    }

    &.next {
      grid-column: 3;
    }
  }
}
</style>
